(()=>{
  const KEY='EasyGamesBadgeCommerceBridgeV1';
  const CONTRACT_KEY='EasyGamesCommerceRulesContractV1';
  const CONTRACT_EVENT='easygames:commerce-contract-change';

  window[KEY]?.destroy?.();

  const bridge={
    target:null,
    originalMatch:null,
    onContractChange:null,
    onSectionLoad:null,
    install(){
      const engine=window.__easyGamesBadgeEngineV6;
      const contract=window[CONTRACT_KEY];
      if(!engine||!contract)return false;

      if(this.target===engine&&this.originalMatch){
        engine.all?.();
        return true;
      }

      this.unpatch();
      const original=engine.match.bind(engine);
      this.target=engine;
      this.originalMatch=original;

      engine.match=(rule,data)=>{
        const active=window[CONTRACT_KEY];
        const rules=active?.contract?.()?.rules;
        if(active&&rules){
          const meta={
            tags:data?.g instanceof Set?data.g:new Set(),
            inventory:Number(data?.i)||0,
            tracked:Boolean(data?.t),
            continueSelling:Boolean(data?.c),
            available:Boolean(data?.e)
          };
          if(rule?.t==='reserve'&&typeof active.reserveMatches==='function'){
            return active.reserveMatches(meta,rules.reserve);
          }
          if(rule?.t==='special_order'&&typeof active.specialMatches==='function'){
            return active.specialMatches(meta,rules.special);
          }
          if(rule?.t==='sold_out'&&typeof active.soldMatches==='function'){
            return active.soldMatches(meta,rules.sold);
          }
        }
        return original(rule,data);
      };

      document.documentElement.dataset.egBadgeCommerceBridge='v1-active';
      engine.all?.();
      return true;
    },
    unpatch(){
      if(this.target&&this.originalMatch){
        this.target.match=this.originalMatch;
      }
      this.target=null;
      this.originalMatch=null;
    },
    destroy(){
      document.removeEventListener(CONTRACT_EVENT,this.onContractChange);
      document.removeEventListener('shopify:section:load',this.onSectionLoad);
      this.unpatch();
      delete document.documentElement.dataset.egBadgeCommerceBridge;
    }
  };

  bridge.onContractChange=()=>requestAnimationFrame(()=>bridge.install());
  bridge.onSectionLoad=()=>requestAnimationFrame(()=>bridge.install());
  document.addEventListener(CONTRACT_EVENT,bridge.onContractChange);
  document.addEventListener('shopify:section:load',bridge.onSectionLoad);
  window[KEY]=bridge;

  const start=()=>bridge.install();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
